module.exports = __webpack_public_path__ + "static/media/1.8_manual.0690bd00.png";